import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ThemeProvider as BaseThemeProvider, loadTheme } from '@fluentui/react';
import { ThemeProviderBackground } from './ThemeProviderBackground';
import { selectThemeFromKey } from './selectThemeFromKey';
import { getIsDarkModeFromThemeKey } from './getIsDarkModeFromThemeKey';
import { useThemeMeControlEffect } from './useThemeMeControlEffect';
import { themeContext } from './themeContext';
import { toggleLightVsDarkTheme } from './toggleLightVsDarkTheme';
import { useAnimationState } from './useAnimationState';
/**
 * Premade wrapper component that provides MSRCEng's theming including hooks for
 * toggling light mode on/off and browser dark mode detection.
 *
 * > Note: don't use the theme provider to set the size of the page.
 * > If you want fullpage, set the page size on one of its parents.
 * > This is to enable cases where a small part of the page can have
 * > its own theme.
 */
export const ThemeProvider = ({ children, overrideTheme, }) => {
    const [themeKey, setThemeKey] = useState(overrideTheme || 'AUTO');
    const { isTransitioning, setIsTransitioning } = useAnimationState();
    /** Whether the currently selected theme is a dark mode theme. */
    const isDarkMode = getIsDarkModeFromThemeKey(themeKey);
    /** The currently selected Fluent Theme */
    const theme = selectThemeFromKey(themeKey);
    useThemeMeControlEffect(isDarkMode);
    /** Select a new theme. */
    const setTheme = (theme, enableTransition = true) => {
        if (enableTransition) {
            setIsTransitioning(true);
        }
        setThemeKey(theme);
    };
    /** Toggle between light and dark mode versions of the theme. */
    const toggle = () => {
        const newTheme = toggleLightVsDarkTheme(themeKey);
        setTheme(newTheme);
    };
    //is this needed?  https://dev-coherence-portal-isabela-slot.azurewebsites.net/storybook/?path=/story/concepts-developer-quick-start--page gives 2 different versions
    useEffect(() => {
        loadTheme(theme);
    }, [theme]);
    return (_jsx(themeContext.Provider, { value: { isTransitioning, isDarkMode, setTheme, themeKey, toggle, theme }, children: _jsx(BaseThemeProvider, { theme: theme, style: { height: '100%' }, children: _jsx(ThemeProviderBackground, { isTransitioning: isTransitioning, children: children }) }) }));
};
